import React from 'react'
import { Helmet } from 'react-helmet'
import striptags from 'striptags'
import { useScript } from './hooks'

function FilledHelmet({title, img, desc, url}) {
  let fullhostname = 'https://www.advanceuw.org'
  const imgpath = ( img && typeof img !== 'undefined' && img.localFile ) 
  ?   `${fullhostname}${img.localFile.childImageSharp.fluid.src}`
  : null
  const cleanDesc = ( desc ) ? striptags(desc) : null

  //load survicate code
  useScript('https://survey.survicate.com/workspaces/db72312bbb976f0480eb1d39389fbd72/web_surveys.js');

  return (
    <Helmet titleTemplate="%s | Wisconsin Foundation &amp; Alumni Association">
      <title>{title}</title>
      <link rel="stylesheet" type="text/css" href="https://cloud.typography.com/7708974/7337212/css/fonts.css" />
      {cleanDesc && 
        <meta name="description" content={cleanDesc} />
      }
      {cleanDesc && 
        <meta property="og:description" content={cleanDesc} />
      }
      {cleanDesc && 
        <meta name="twitter:description" content={cleanDesc} />
      }
      <meta property="og:title" content={`${title} | Wisconsin Foundation & Alumni Association`} />
      {url && 
      <meta property="og:url" content={url} />
      }
      
      {imgpath && 
        <meta property="og:image" content={imgpath} />
      }
      {imgpath && 
        <meta name="twitter:card" content="summary_large_image" />
      }
      <meta name="facebook-domain-verification" content="ioeuxltev1xa12p8urw470rrdlixtw" />

    </Helmet>
  )
}

export default FilledHelmet